let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jp2LC")).then(() => parcelRequire('dxTQy'));